import { Component, NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginGuard } from './shared/guards/login/login.gaurd';
import { StartupGuard } from './shared/guards/startup/startup.guard';
import { PermissionGuard } from './shared/guards/permission/permission.guard';
import { PermissionDefinitions } from './services/authorization/permission-definitions';
import { AppOpenPageComponent } from './pages/app-open/app-open.page';

/** Never rendered — StartupGuard always redirects before activation. */
@Component({ template: '', standalone: true })
class StartupPlaceholderComponent {}

const routes: Routes = [
  {
    path: 'startup',
    canActivate: [StartupGuard],
    component: StartupPlaceholderComponent,
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./pages/onboarding/onboarding.module').then((m) => m.OnboardingPageModule),
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/account/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'landing',
    loadChildren: () =>
      import('./pages/account/landing/landing.module').then((m) => m.LandingPageModule),
  },
  {
    path: 'startup-connectivity',
    loadChildren: () =>
      import('./pages/startup-connectivity/startup-connectivity.module').then(
        (m) => m.StartupConnectivityPageModule,
      ),
  },
  {
    path: 'forget-password',
    loadChildren: () =>
      import('./pages/account/forget-password/forget-password.module').then(
        (m) => m.ForgetPasswordPageModule,
      ),
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import('./pages/account/reset-password/reset-password.module').then(
        (m) => m.ResetPasswordPageModule,
      ),
  },
  {
    path: 'configureLicenseCode',
    loadChildren: () =>
      import('./pages/configure-license/configure-license.module').then(
        (m) => m.ConfigureLicensePageModule,
      ),
  },
  {
    path: 'treatment/:patientId',
    canLoad: [LoginGuard, PermissionGuard],
    data: {
      permissions: [PermissionDefinitions.PATIENT_LIST_VIEW],
    },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/treatment/treatment.module').then((m) => m.TreatmentPageModule),
      },
      {
        path: ':encounterId',
        loadChildren: () =>
          import('./pages/treatment/treatment.module').then((m) => m.TreatmentPageModule),
      },
    ],
  },
  {
    path: 'protocol/:id',
    canLoad: [LoginGuard, PermissionGuard],
    data: {
      permissions: [PermissionDefinitions.PROTOCOL_LIST_VIEW],
    },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/protocol/protocol.module').then((m) => m.ProtocolDetailPageModule),
      },
    ],
  },
  {
    path: 'welcome',
    canLoad: [LoginGuard],
    loadChildren: () => import('./pages/welcome/welcome.module').then((m) => m.WelcomePageModule),
  },
  {
    path: 'profile',
    canLoad: [LoginGuard, PermissionGuard],
    data: {
      permissions: [PermissionDefinitions.ACCOUNT_PROFILE_VIEW],
    },
    loadChildren: () =>
      import('./pages/account/profile/profile.module').then((m) => m.ProfilePageModule),
  },
  {
    path: 'ble-debug',
    canLoad: [LoginGuard],
    loadChildren: () =>
      import('./pages/ble-debug/ble-debug.module').then((m) => m.BleDebugPageModule),
  },
  {
    path: 'app/open',
    component: AppOpenPageComponent,
  },
  {
    path: '**',
    redirectTo: 'startup',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    AppOpenPageComponent,
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
